import logo from "../../../assets/logo-main.svg";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { openNewLogin } from "../../../store/slices/modalSlice";
import DesktopSearch from "./DesktopSearch";
import { UserDataType } from "../../../types/navbarTypes";
import CartPopup from "../../cartToast/CartPopup";
import { logoutFun } from "../../../config/auth";

interface Notification {
  title: string;
  message: string;
  time: string;
}

interface Props {
  isActive?: boolean;
  totalItemInCart?: number;
  hasNotification?: boolean;
  data?: UserDataType | null;
  notifications?: Notification[];
}

const DesktopNavbar: React.FC<Props> = ({
  isActive,
  data,
  totalItemInCart,
  notifications,
  hasNotification,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleOpenLogin = () => {
    dispatch(openNewLogin());
  };

  const recentlyAddedd = useSelector(
    (state: { modal: { recentlyAdded: boolean } }) => state.modal.recentlyAdded
  );

  return (
    <>
      <section className="heder-main disable">
        <div className="container p-0">
          <div className="row align-items-center">
            <div className="col-md-2 col-lg-2 col-4 ">
              <div className="row">
                <div className="col wow animate__fadeInLeft">
                  <img
                    loading="lazy"
                    src={logo}
                    className="img-fluid"
                    alt="Company Logo"
                    onClick={() => navigate("/")}
                  />
                </div>
              </div>
            </div>

            <DesktopSearch />

            <div className="col-md-3 col-lg-3 col-2 d-flex justify-content-end align-items-center gap-4 d-none d-md-flex">
              {/* SHOPPING CART */}
              <div>
                <img
                  src="https://goodhand.b-cdn.net/Assets/cart/guarantee.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="cart-icon-wrapper">
                <Link to="/cart">
                  <img
                    src="https://goodhand.b-cdn.net/Assets/cart/shopping-bag.svg"
                    className="img-fluid"
                  />
                  <span className="cart-badge">{totalItemInCart}</span>
                </Link>

                {recentlyAddedd && <CartPopup />}
              </div>

              {/* Notifications Dropdown */}
              {isActive && (
                <Dropdown className="dropdown" hidden>
                  <Dropdown.Toggle
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: 0,
                      color: "white",
                    }}
                    className="notification-icon"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fas fa-bell" style={{ color: "black" }}></i>
                    {hasNotification && (
                      <span className="notification-dot"></span>
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu notification-panel dropdown-menu-end">
                    {notifications && notifications.length > 0 ? (
                      notifications.map((notification, index) => (
                        <Dropdown.Item
                          key={index}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <h6 className="notification-title">
                              {notification.title}
                            </h6>
                            <p className="notification-message">
                              {notification.message}
                            </p>
                            <span className="notification-time">
                              {notification.time}
                            </span>
                          </div>
                        </Dropdown.Item>
                      ))
                    ) : (
                      <Dropdown.Menu className="no-notifications">
                        <p>No notifications</p>
                      </Dropdown.Menu>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}

              <div>
                {isActive ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      id="dropdown-button-dark-example1"
                      variant="secondary"
                      className="btn btn-secondary dropdown-toggle profile-dropdown-btn"
                    >
                      <img
                        src="https://goodhand.b-cdn.net/Assets/cart/profile.svg"
                        className="img-fluid"
                        alt=""
                      />
                      {data?.userFullName}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu">
                      {/* <Dropdown.Item onClick={() => navigate("/orderflow")}> */}
                      {/* <Dropdown.Item onClick={() => navigate("/booking")}>
                        Order
                      </Dropdown.Item> */}
                      <Dropdown.Item 
                        onClick={() => {
                          logoutFun(dispatch, navigate);
                        }}>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Dropdown>
                    <Dropdown.Toggle
                      id="dropdown-button-dark-example1"
                      variant="secondary"
                      className="btn btn-secondary dropdown-toggle profile-dropdown-btn"
                    >
                      <img
                        src="https://goodhand.b-cdn.net/Assets/cart/profile.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={handleOpenLogin}>
                        Login
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DesktopNavbar;
